export const ContractType = {
  MAIN: 'MAIN',
  ADDITIONAL: 'ADDITIONAL',
} as const;

export type ContractType = keyof typeof ContractType;
